import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7de53a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offersGrid" }

import { PartnerOffer } from '@/features/partnerOffers/model';
import OfferCard from './OfferCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OffersList',
  props: {
    offers: null,
    context: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.offers, (offer) => {
      return (_openBlock(), _createElementBlock("div", {
        key: offer.id
      }, [
        _createVNode(OfferCard, {
          offer: offer,
          context: __props.context
        }, null, 8, ["offer", "context"])
      ]))
    }), 128))
  ]))
}
}

})